export function decimalToHexColor(color: number) {
  return `#${(`000000${color.toString(16)}`).slice(-6)}`;
}

export function hexColorToDecimal(color: string) {
  return parseInt(color.replaceAll('#', ''), 16);
}
